export const CURRENT_CITY = 'currentCity'
